// https://codingjump.com/posts/2022/react-zoom
import classnames from 'classnames'
import React, { FunctionComponent, useState } from 'react'
import { Loader, LoaderType } from '../Loader'

interface IDefaultProps {
  border: boolean
  src: string
  className: string
  containerClassName?: string
  blockClick?: boolean
  style?: React.CSSProperties
}

interface IProps extends Partial<IDefaultProps> {}

const defaultProps: IDefaultProps = {
  className: null,
  border: false,
  src: null,
  containerClassName: null,
  blockClick: false,
  style: {},
}

const PdfZoom: FunctionComponent<IProps> = ({
  src,
  border,
  className,
  containerClassName,
  blockClick,
  style,
  ...rest
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(true)

  const handlePdfLoaded = () => {
    setIsLoading(false)
  }

  return (
    <>
      <div className={classnames('relative', containerClassName)}>
        <div
          {...rest}
          className={className}
          onClick={() => {
            if (blockClick) {
              return
            }
          }}
          style={style}
        >
          {isLoading && (
            <div className='rounded-xl flex items-center justify-center absolute w-full h-full bg-gray-200 top-[0]'>
              <Loader type={LoaderType.button} />
            </div>
          )}
          <iframe
            src={`${src}#toolbar=0&navpanes=0&scrollbar=0`}
            width='100%'
            height='300px'
            onLoad={handlePdfLoaded}
            style={{ border: border ? '1px solid black' : 'none' }}
          >
            <p>PDF cannot be displayed.</p>
          </iframe>
        </div>
      </div>
    </>
  )
}

PdfZoom.defaultProps = defaultProps

export { PdfZoom }
